import { render, staticRenderFns } from "./Faculty.vue?vue&type=template&id=54d08026&scoped=true"
import script from "./Faculty.vue?vue&type=script&lang=js"
export * from "./Faculty.vue?vue&type=script&lang=js"
import style0 from "./Faculty.vue?vue&type=style&index=0&id=54d08026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d08026",
  null
  
)

export default component.exports